import { ProjectStage } from '@shared/enums/project-stage.enum';
import { ProjectDashboardStepConfig } from './project-dashboard-stepper.component';

export const ProjectDashboardSteps: ReadonlyArray<ProjectDashboardStepConfig> = [
  {
    key: ProjectStage.STAGE_FIRST_CONTACT,
    label: 'Erstkontakt',
    icon: '/assets/img/ic-dashboard-step-first-contact.svg'
  },
  { key: ProjectStage.STAGE_CREATOR, label: 'Anfrage', icon: '/assets/img/ic-dashboard-step-1.svg' },
  {
    key: ProjectStage.STAGE_CREATED,
    label: 'Erstberatung',
    icon: '/assets/img/ic-dashboard-step-2.svg'
  },
  {
    key: ProjectStage.STAGE_MEETING,
    label: 'Vor Ort Termin',
    icon: '/assets/img/ic-dashboard-step-3.svg'
  },
  { key: ProjectStage.STAGE_ESTIMATE, label: 'Angebot', icon: '/assets/img/ic-dashboard-step-4.svg' },
  {
    key: ProjectStage.STAGE_NEGOTIATIONS,
    label: 'Verhandlung',
    icon: '/assets/img/ic-dashboard-step-5.svg'
  },
  { key: ProjectStage.STAGE_PLANNING, label: 'Vor Planung', icon: '/assets/img/ic-dashboard-step-7.svg' },
  { key: ProjectStage.STAGE_WON, label: 'Gewonnen', icon: '/assets/img/ic-dashboard-step-6.svg' },
  {
    key: ProjectStage.STAGE_BEFORE_REALIZATION,
    label: 'In Planung',
    icon: '/assets/img/ic-dashboard-step-7.svg'
  },
  {
    key: ProjectStage.STAGE_BEFORE_EXECUTION,
    label: 'Vor Ausführung',
    icon: '/assets/img/ic-dashboard-step-8.svg'
  },
  {
    key: ProjectStage.STAGE_REALIZATION,
    label: 'In Ausführung',
    icon: '/assets/img/ic-dashboard-step-8.svg'
  },
  { key: ProjectStage.STAGE_APPROVED, label: 'Abnahme', icon: '/assets/img/ic-dashboard-step-9.svg' },
  {
    key: ProjectStage.STAGE_PAYMENT,
    label: 'Schlussabrechnung',
    icon: '/assets/img/ic-dashboard-step-10.svg'
  },
  { key: ProjectStage.STAGE_FINISHED, label: 'Erledigt', icon: '/assets/img/ic-dashboard-step-11.svg' },
  { key: ProjectStage.STAGE_COMPLAINT, label: 'Gewährleistung', icon: '/assets/img/ic-warning-dark.svg' },
  { key: ProjectStage.STAGE_LOST, label: 'Abgebrochen', icon: '/assets/img/close-icon.svg' }
];
